const notFoundPageStyle = {
  body: `display: -webkit-box;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        color: "#0e0620";
        font-size: 1em;`,
  container: {
    height: '100%',
    marginTop: '200px',
    marginBottom: '200px',
    '@media (max-width: 768px)': {
      marginTop: '70px',
      marginBottom: '70px',
    },
  },
}

export default notFoundPageStyle
